var fi = {
  "Add Quantity Breaks to your product page": "Lisää määräalennukset tuotesivullesi",
  "Add Upsell.com to your ": "Lisää Upsell.com ",
  "All time": "Kaikki ajat",
  "and select": "ja valitse",
  "button": "-painiketta",
  "Cart drawer page": "Ostoskorilaatikko-sivu",
  "Cart page": "Ostoskorisivu",
  "Check status": "Tarkista tila",
  "Checkout page": "Kassasivu",
  "Click": "Klikkaa",
  "Click on": "Klikkaa",
  "Click the": "Klikkaa",
  "Custom slot": "Mukautettu paikka",
  "Custom slots": "Mukautetut paikat",
  "Custom Slots": "Mukautetut paikat",
  "contact support.": "ota yhteyttä tukeen.",
  "from the right sidebar": "oikeasta sivupalkista",
  "Go to App Embeds": "Siirry sovellusten lisäyksiin",
  "Go to your Cart drawer page": "Mene Ostoskorilaatikko-sivullesi",
  "Go to your Cart page": "Mene Ostoskorisivullesi",
  "Go to your Checkout page": "Mene Kassasivullesi",
  "Go to your Order status page": "Mene Tilauksen tila -sivullesi",
  "Go to your Post purchase page": "Mene Ostoksen jälkeiselle sivullesi",
  "Go to your Product page": "Mene Tuotesivullesi",
  "Go to your Thank you page": "Mene Kiitos-sivullesi",
  "items": "tuotetta",
  "in the left sidebar": "vasemmassa sivupalkissa",
  "Last 12 months": "Viimeiset 12 kuukautta",
  "Last 30 days": "Viimeiset 30 päivää",
  "Last 365 days": "Viimeiset 365 päivää",
  "Last 7 days": "Viimeiset 7 päivää",
  "Last 90 days": "Viimeiset 90 päivää",
  "Last month": "Viime kuu",
  "Last year": "Viime vuosi",
  "Make sure": "Varmista",
  "Need assistance? Contact our support team for help.": "Tarvitsetko apua? Ota yhteyttä tukitiimiimme.",
  "Order status page": "Tilauksen tila -sivu",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Sovelluksemme on parhaillaan pienen taikuuden alla parantaaksemme kokemustasi.",
  "Post purchase page": "Ostoksen jälkeinen sivu",
  "Product page": "Tuotesivu",
  "Save": "Tallenna",
  "Scroll to the bottom and select": "Vieritä alas ja valitse",
  "Select": "Valitse",
  "Success. Please continue.": "Onnistui. Ole hyvä ja jatka.",
  "Thank you page": "Kiitos-sivu",
  "The Upsell.com team.": "Upsell.com-tiimi.",
  "The Upsell.com widget is not placed on ": "Upsell.com-widget ei ole sijoitettu sivulle ",
  ". Please follow the steps above or ": ". Noudata yllä olevia ohjeita tai ",
  "Today": "Tänään",
  "toggle is on": "kytkin on päällä",
  "Total": "Yhteensä",
  "under": "kohdasta",
  "We apologize for any inconvenience caused,": "Pahoittelemme aiheutunutta haittaa,",
  "We apologize for any inconvenience caused.": "Pahoittelemme aiheutunutta haittaa.",
  "We'll be done in a few minutes!": "Olemme valmiita muutamassa minuutissa!",
  "We're improving our services!": "Parannamme palveluitamme!",
  "Widget already added": "Widget on jo lisätty",
  "Yesterday": "Eilen",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Otit widgetin käyttöön verkkokaupassasi, mutta et tallentanut sitä Upsell-editorissa",
  "You placed the widget on the ": "Sijoitit widgetin sivulle ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", mutta et tallentanut sitä Shopify-editorissa. Palaa sivulle ",
  " and save the changes.": " ja tallenna muutokset."
};

export { fi as default };
//# sourceMappingURL=fi.json.js.map
